import createVerification from './admin/store-dashboard/create-verification';
import verifyStore from './admin/store-dashboard/verify-store';
import notificationCenter from './admin/notification-center';
import createCollection from './admin/create-collection';
import registerInterests from './register/interests';
import storeSettings from './admin/store-settings';
import orderOverview from './buyer/order-overview';
import registerAddress from './register/address';
import multiselect from './plugins/multiselect';
import breadcrumbs from './partials/breadcrumbs';
import filteredProducts from './buyer/products';
import pagination from './partials/pagination';
import registerMethod from './register/method';
import saveProduct from './admin/save-product';
import orderConfirmed from './order/confirmed';
import registerPhone from './register/phone';
import orderPreview from './order/preview';
import statuses from './partials/statuses';
import dropzone from './plugins/dropzone';
import dashboard from './admin/dashboard';
import wishList from './buyer/wish-list';
import orderWizard from './order/wizard';
import staff from './admin/staff/staff';
import products from './admin/products';
import delivery from './admin/delivery';
import settings from './buyer/settings';
import showOrders from './show-orders';
import sidebar from './admin/sidebar';
import reviews from './buyer/reviews';
import landing from './buyer/landing';
import product from './buyer/product';
import toastr from './plugins/toastr';
import myStores from './my-stores.js';
import table from './partials/table';
import month from './partials/month';
import orderInfo from './order/info';
import common from './buyer/common';
import stores from './buyer/stores';
import order from './admin/order';
import swal from './plugins/swal';
import role from './admin/role';
import user from './admin/user';
import cart from './buyer/cart';
import noData from './no-data';
import images from './images';
import faq from './buyer/faq';
import find from './buyer/find';
import chat from './chat';

export default {
    createVerification,
    notificationCenter,
    registerInterests,
    filteredProducts,
    createCollection,
    registerAddress,
    orderConfirmed,
    registerMethod,
    orderOverview,
    storeSettings,
    registerPhone,
    orderPreview,
    verifyStore,
    saveProduct,
    multiselect,
    orderWizard,
    breadcrumbs,
    pagination,
    showOrders,
    orderInfo,
    dashboard,
    myStores,
    delivery,
    settings,
    products,
    wishList,
    dropzone,
    statuses,
    sidebar,
    product,
    landing,
    reviews,
    common,
    stores,
    noData,
    toastr,
    images,
    table,
    order,
    staff,
    month,
    chat,
    user,
    find,
    swal,
    cart,
    role,
    faq
};
